// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"375c9722","667":"011e514e"}[chunkId] + ".chunk.js";
};